import React, { useEffect, useMemo, useState, useRef } from "react";
import Button from "components/button/button";
import UserGearIconSVG from "assets/svg/user-gear-icon";
import GraduationCapIconSVG from "assets/svg/graduation-cap-icon";
import ChatUserIconSVG from "assets/svg/chat-user-icon";
import BriefCaseExperienceIconSVG from "assets/svg/brief-case-icon";
import AwardsIconSVG from "assets/svg/awards-icon";
import FileUserRepresentationIconSVG from "assets/svg/file-user-icon";
import _ from "lodash";
import { HiOutlinePencil } from "react-icons/hi";
import { FiCheck } from "react-icons/fi";
import { TbBulb } from "react-icons/tb";
import CreatableSelect from "components/select/creatable";
import TextArea from "components/textarea/textarea";
import { urlSerializer,currentLang as lang } from "utils/utils";
import LoadingIndicator from "assets/svg/loading-indicator";
import toast from "react-hot-toast";
import { useOccupations } from "redux/modules/occupation/hooks";
import { useTranslation } from "react-i18next";
import PopInfo from "components/info-popup/pop-info";
import Popup from "reactjs-popup";
import { FaEllipsisH  } from "react-icons/fa";
import { IoLanguageOutline } from "react-icons/io5";


const ICONS = {
  skills: <UserGearIconSVG className="m-auto" />,
  education: <GraduationCapIconSVG className="m-auto" />,
  training: <ChatUserIconSVG className="m-auto" />,
  experience: <BriefCaseExperienceIconSVG className="m-auto" />,
  awards: <AwardsIconSVG className="m-auto" />,
  representation: <FileUserRepresentationIconSVG className="m-auto" />,
  trivia: <TbBulb className="m-auto text-3xl text-lightBlack" />,
};

export default function ProfessionalInformation(props) {
  const { t } = useTranslation();
  const buttonProps = {
    edit: {
      btnName: t("edit"),
      icon: <HiOutlinePencil />,
      btnClass: "relative px-6 py-2 bg-white hover:bg-gray hover:rounded-b-md justify-start w-full",
      btnTextClass:
        "text-lg  flex flex-row items-center gap-2",
    },
    save: {
      btnName: t("saveChanges"),
      icon: <FiCheck className="text-lg" />,
      btnClass: "relative py-3.6 px-5.5 bg-primary hover:bg-darkPrimary",
      btnTextClass:
        "text-sm text-white font-semibold flex items-center space-x-1.6",
    },
  };
  const { profile, userData, setUserData, onHasProfessionalInfoChange } = props;
  const { http, localstorage } = global.services;
  const {
    refresh: refreshOccupation,
    initialize: initializeOccupation,
    occupations,
    setOccupations,
    addOccupation,
  } = useOccupations();

  const [edit, setEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [state, setState] = useState({
    id: null,
    skills: "",
    education: null,
    training: null,
    experience: null,
  });
  
  const [professional, setProfessional] = useState([
    {
      label: "Abilities / Skills / Specialties",
      // value:  props.isYourProfile ? userData?.profile?.occupations : (profile?.occupations  || []),
      value:  "",
      icon: ICONS.skills,
      form: "textarea",
      formProps: {
        name: "skills",
      },
    },
    {
      label: "Education",
      value: "",
      icon: ICONS.education,
      form: "textarea",
      formProps: {
        name: "education",
      },
    },
    {
      label: "Training",
      value: "",
      icon: ICONS.training,
      form: "textarea",
      formProps: {
        name: "training",
      },
    },
    {
      label: "Experience",
      value: "",
      icon: ICONS.experience,
      form: "textarea",
      formProps: {
        name: "experience",
      },
    },
    {
      label: "Awards",
      value: "",
      icon: ICONS.awards,
      form: "textarea",
      formProps: {
        name: "awards",
      },
    },
    {
      label: "Representation",
      value: "",
      icon: ICONS.representation,
      form: "textarea",
      formProps: {
        name: "representation",
      },
    },
    {
      label: "Trivia/Fun Facts",
      value: "",
      icon: ICONS.trivia,
      form: "textarea",
      formProps: {
        name: "trivia",
      },
    },
  ]);
  const optionRef = useRef();
  const [loadingTranslate , setTransLoad] = useState(false);
  const [currentLang, setLang] = useState('en'); 
  const [showMoreOption, setShowMoreOption] = useState();
  const preEditState = useRef(null);

  useEffect(() => {
    // Snapshot the values when entering edit mode so Cancel can revert them.
    if (edit) preEditState.current = state;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [edit]);

  const onClickCancel = () => {
    if (preEditState.current) {
      setState(preEditState.current);
    }
    setEdit(false);
  };
  
   useEffect(() => {
        window.addEventListener(
            "scroll",
            () => {  
                if (optionRef.current) {
                    optionRef.current.close();
                }
            },
            true
        );
        return () => {
            window.removeEventListener("scroll", () => {});
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
  //============================== functions ========================
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    // if (name === "skills") {
    //   const valueMap = value.map((val) => val.label);
    //   setState((prev) => ({
    //     ...prev,
    //     [name]: valueMap,
    //   }));
    // } else {
    //   setState((prev) => ({
    //     ...prev,
    //     [name]: value,
    //   }));
    // }

    setState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const createPFInformation = async () => {
    try {
      const { data } = await http.post(`public/professional-informations`, {
        user_profile_id: profile.id,
        skills: "",
        education: "",
        training: "",
        experience: "",
      });
      if (data) {
        toast.message(t('professionalInformationSuccessfully'));
        getInfo();
      }
    } catch (error) {
      toast.error(
        error?.data?.message || t('somethingWentWrong')
      );
    }
  }; 
  const getInfo = async (langProf='en') => {
    try {
      const { data } = await http.get(`public/professional-informations`, {
        user_profile_id: profile.id,
      });
      const {translation ={}} = data;
      const useLang = langProf || currentLang;
      if (!_.isEmpty(data)) {
        setState({
          id: data.id,
          // skills: props.isYourProfile ? userData?.profile?.occupations : (profile?.occupations || []),
          skills: data.skills ?? "",
          education: data.education ?? "",
          training: data.training ?? "",
          experience: data.experience ?? "",
          awards: data.awards ?? "",
          representation: data.representation ?? "",
          trivia: data.trivia ?? "",
        });
        setProfessional([
          {
            label: t('abilitiesSkills'),
            // value: userData?.profile?.occupations,
            // value: props.isYourProfile ? userData?.profile?.occupations : (profile?.occupations  || []),
            value: data.skills,
            display:translation?.[useLang]?.skills || data.skills || "",
            icon: ICONS.skills,
            form: "textarea",
            formProps: {
              name: "skills",
            },
          },
          {
            label: t("education"),
            value: data.education ?? "",
            display:translation?.[useLang]?.education || data.education || "",
            icon: ICONS.education,
            form: "textarea",
            formProps: {
              name: "education",
            },
          },
          {
            label: t("training"),
            display:translation?.[useLang]?.training || data.training || "",
            value: data.training ?? "",
            icon: ICONS.training,
            form: "textarea",
            formProps: {
              name: "training",
            },
          },
          {
            label: t("experience"),
            display:translation?.[useLang]?.experience || data.experience || "",
            value: data.experience ?? "",
            icon: ICONS.experience,
            form: "textarea",
            formProps: {
              name: "experience",
            },
          },
          {
            label: t("awards"),
            display:translation?.[useLang]?.awards || data.awards || "",
            value: data.awards ?? "",
            icon: ICONS.awards,
            form: "textarea",
            formProps: {
              name: "awards",
            },
          },
          {
            label: t("representation"),
            display:translation?.[useLang]?.representation || data.representation || "",
            value: data.representation ?? "",
            icon: ICONS.representation,
            form: "textarea",
            formProps: {
              name: "representation",
            },
          },
          {
            label: t("triviaFunFacts"),
            display:translation?.[useLang]?.trivia || data.trivia || "",
            value: data.trivia ?? "",
            icon: ICONS.trivia,
            form: "textarea",
            formProps: {
              name: "trivia",
            },
          }
        ]);
        //update state to false
      } else {
        createPFInformation();
      }
    } catch (error) {
      toast.error(
        error?.data?.message || t('somethingWentWrong')
      );
    }
  };

  const onClickSave = async () => {
    try {
      if (state.id) {
        setLoading(true);
        const payload = _.clone(state);
        delete payload.id;
        if (!_.isEmpty(payload)) {
          const { data } = await http.put(
            `public/professional-informations/${state.id}`,
            payload
          );
          if (data?.professional_info?.id) {
            toast.success(t('professionalInformationUpdated'));
            updateProfessionalInfo(data)
          }
        }
      } else {
        return toast.error(t('professionalInformationCannotSave'));
      }
    } catch (error) {
      toast.error(
        error?.data?.message || t('somethingWentWrong')
      );
      setLoading(false);
      setEdit(false);
    } finally {
      setLoading(false);
      setEdit(false);
    }
  };

  const getOccupations = async () => {
    try {
      const url = urlSerializer("public/occupations", {
        user_profile_id: profile.id,
      });
      const { data } = await http.get(url);
      const options = data.map((opt) => ({
        label: opt.name,
        value: opt.id,
      }));
      setOccupations(options);
    } catch (err) {
      console.error("getOccupations", err);
    }
  };

  const createOccupation = async (option) => {
    try {
      let { data } = await http.post("public/occupations", {
        user_id: userData.user.id,
        user_profile_id: profile.id,
        occupation: option,
      });
      console.log("data", data);
      console.log("value", option);
      setState((prev) => ({
        ...prev,
        skills: [...prev.skills, option],
      }));
      addOccupation({
        label: option,
        value: data?.data?.id,
      });
    } catch (err) {
      console.log(err);
    }
  };

  //============================== useEffects ========================
  useEffect(() => {
    if (profile && userData) {
      getInfo(lang());
      setLang(userData?.profile?.lang);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData, profile]);

  useEffect(() => {
    if (initializeOccupation) getOccupations();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshOccupation, initializeOccupation]);

  useEffect(() => {
    let hasInfo = false;
    for(const item of professional) {
      if(Array.isArray(item.value)) {
        if( item.value.length > 0) hasInfo = true;
      } else if(!!item.value) {
        hasInfo = true;
      }
    }

    if(typeof onHasProfessionalInfoChange === 'function') {
      onHasProfessionalInfoChange(hasInfo);
    }
  }, [professional, onHasProfessionalInfoChange]);
  
  const translateProfessionalInfo = async()=>{
    if (state.id) {
        try{
            setTransLoad(true)
            let curLang = localStorage.getItem('lang');
            const { data } = await http.put(`public/professional-info/${state.id}/translate`,{
                lang:curLang
            }); 
            if(data.professional_info){
                updateProfessionalInfo(data)
                toast.success(t('completedTranslate'))
            }else{
                toast.success(t('beenTranslated'));
            }
            setTransLoad(false)
        }catch(e){
            setTransLoad(false)
            toast.error(t('somethingWentWrong'));
        }
    }
  }

  const updateProfessionalInfo = async (data, language = null)=>{
    const resultValue = data.professional_info;
    const {translation = {}} = resultValue || {};
    const lang = language || userData?.profile?.lang;
    // const profData = data.profile;
    // // ========= set user data =================
    // const newUserData = {
    //   ...userData,
    //   profile: {
    //     ...userData.profile,
    //     occupations: profData.occupations,
    //   },
    // };
    // localstorage.set("user_data", JSON.stringify(newUserData));
    // setUserData(newUserData);
    //========= set professional =================
    setProfessional([
      {
        label: t("abilitiesSkills"),
        value: resultValue.skills,
        display:translation?.[lang]?.skills || resultValue.skills,
        icon: ICONS.skills,
        form: "textarea",
        formProps: {
          name: "skills",
        },
      },
      {
        label: t("education"),
        value: resultValue.education ?? "",
        display:translation?.[lang]?.education || resultValue.education || "",
        icon: ICONS.education,
        form: "textarea",
        formProps: {
          name: "education",
        },
      },
      {
        label: t("training"),
        value: resultValue.training ?? "",
        display:translation?.[lang]?.training || resultValue.training || "",
        icon: ICONS.training,
        form: "textarea",
        formProps: {
          name: "training",
        },
      },
      {
        label: t("experience"),
        value: resultValue.experience ?? "",
        display: translation?.[lang]?.experience || resultValue.experience || "",
        icon: ICONS.experience,
        form: "textarea",
        formProps: {
          name: "experience",
        },
      },
      {
        label: t("awards"),
        value: resultValue.awards ?? "",
        display: translation?.[lang]?.awards || resultValue.awards || "",
        icon: ICONS.awards,
        form: "textarea",
        formProps: {
          name: "awards",
        },
      },
      {
        label: t("Representation"),
        value: resultValue.representation ?? "",
        display: translation?.[lang]?.representation || resultValue.representation || "",
        icon: ICONS.representation,
        form: "textarea",
        formProps: {
          name: "representation",
        }
      },
      {
        label: t("triviaFunFacts"),
        value: resultValue.trivia ?? "",
        display:translation?.[lang]?.trivia || resultValue.trivia || "",
        icon: ICONS.trivia,
        form: "textarea",
        formProps: {
          name: "trivia",
        },
      }
    ]);
    //update state to false
    setLoading(false);
    // setEdit(false);
  }

  useEffect(()=>{
     updateProfessionalInfo({professional_info:state}, lang())
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[lang(),state])
  
  return (
    <div className="w-full bg-white rounded-md px-5 2md:pl-29 2md:pr-24.5 py-10 md:pb-14 md:pt-8">
      <div className="w-full flex justify-between flex-wrap items-center mb-8">
        <div className="flex flex-row gap-x-2 items-center">
          <h1 className="text-base 2sm:text-2xl font-semibold text-lightBlack">
            {t('professionalInformation')}
          </h1>
          <PopInfo containerClass="relative" type="professional_information" verticalDirection="top" />
        </div>
        {props.isYourProfile && (
          <>
          {
            edit ?
            <div className="flex flex-row items-center gap-x-3.5">
              <Button
                buttonName={t("cancel")}
                buttonTextClass="text-sm text-lightBlack font-bold"
                buttonRadius="6px"
                buttonClass="relative py-3.6 px-5.5 bg-thBg hover:bg-gray"
                disabled={loading}
                onClick={onClickCancel}
              />
              <Button
                buttonName={buttonProps.save.btnName}
                buttonTextClass={buttonProps.save.btnTextClass}
                iconPosition="left"
                icon={buttonProps.save.icon}
                buttonRadius="6px"
                buttonClass={buttonProps.save.btnClass}
                loadingIcon={
                  loading ? (
                    <LoadingIndicator className="text-white w-4 h-4" />
                  ) : null
                }
                disabled={loading}
                onClick={onClickSave}
              />
            </div>
              :
            <Popup
              ref={optionRef}
              position="bottom right"
              open={showMoreOption}
              onClose={() => setShowMoreOption(false)}
              arrow={false}
              contentStyle={{ marginTop: 10, marginLeft: 5 }}
              trigger={
                  <button
                      className="py-0 bg-thBg rounded-md 3md:py-4 3md:px-5 px-3"
                      onClick={() =>
                          setShowMoreOption((open) => !open)
                      }
                  >
                      <FaEllipsisH className="p-0 m-0" />
                  </button>
              }
            >
              <div className="flex flex-col shadow-lg rounded-md bg-white">
                  <ul className="w-full">
                      <li className="hover:bg-gray hover:rounded-md">
                          <Button
                            buttonName={
                              edit ? buttonProps.save.btnName : buttonProps.edit.btnName
                            }
                            buttonTextClass={
                              edit
                                ? buttonProps.save.btnTextClass
                                : buttonProps.edit.btnTextClass
                            }
                            iconPosition="left"
                            icon={edit ? buttonProps.save.icon : buttonProps.edit.icon}
                            buttonRadius="6px"
                            buttonClass={
                              edit ? buttonProps.save.btnClass : buttonProps.edit.btnClass
                            }
                            loadingIcon={
                              loading ? (
                                <LoadingIndicator className="text-white w-4 h-4" />
                              ) : null
                            }
                            disabled={loading}
                            onClick={() => {
                              if (edit) {
                                onClickSave();
                              } else {
                                setEdit((prev) => !prev);
                              }
                            }}
                          />
                      </li>
                      <li>
                          <Button
                              disabled={loadingTranslate}
                              buttonName={
                                  <div className="flex gap-2 items-center">
                                      <IoLanguageOutline/>
                                      <div>{t('translate')}</div>
                                  </div> 
                              }
                              buttonTextClass="text-lg  flex flex-row items-center gap-2"
                              buttonRadius="6px"
                              icon={
                              loadingTranslate ? (
                                  <LoadingIndicator className="text-primary w-4 h-4" />
                              ) : null
                              }
                              buttonClass="relative px-6 py-2 bg-white hover:bg-gray hover:rounded-b-md justify-start w-full"
                              onClick={translateProfessionalInfo}
                          />
                      </li>                     
                  </ul>
              </div>
            </Popup> 

            }
          </>
        )}
      </div>
      <div className="w-full grid gap-y-12 max-w-screen-2smd">
        {/* ==================== BIO =================================== */}
        <div className="w-full grid gap-y-12">
          {professional.map((obj, index) => (
            <div
              className={`${
                // props.isYourProfile
                  // ? "w-full flex flex-start items-start space-x-6"
                  // : 
                  ((() => {
                    if(['string' , 'number'].includes(typeof obj?.value) && !!obj?.value) {
                      return true;
                    }

                    if(Array.isArray(obj?.value)) {
                      if((obj?.value.length || 0) > 0) {
                        return true;
                      }
                    }
                   
                    return false;
                  })() || edit)
                  ? "w-full flex flex-start items-start space-x-6"
                  : "hidden"
              }`}
              key={index}>
              <div className="w-15 h-15 rounded-full bg-bGray grid">
                {obj.icon}
              </div>
              <div style={{ width: "calc(100% - 60px)" }}>
                <h3 className="text-base 2sm:text-xl text-lightBlack font-semibold">
                  {obj.label}
                </h3>
                {edit ? (
                  <div className="w-full mt-3">
                    <FormBuilder
                      type={obj.form}
                      name={obj.formProps.name}
                      placeholder={obj.label}
                      onChange={handleInputChange}
                      defaultValue={obj.value}
                      occupations={occupations}
                      onCreateOption={createOccupation}
                      skills={state.skills}
                    />
                  </div>
                ) : (
                  <>
                    {typeof obj.value !== "object" ? (
                      <p className="text-base leading-6.7 tracking-tightest text-darkerGray mt-1.5">
                        {_.isEmpty(obj.display) ? "--" : obj.display.split("\n").map((display, index) => (
                          <React.Fragment key={index}>
                            {display}
                            <br />
                          </React.Fragment>
                        ))}
                      </p>
                    ) : (
                      <div className="w-full flex flex-start flex-row flex-wrap gap-2">
                        {(obj.display || []).map((display, index) => {
                          return (
                            <div
                              className="py-2 px-3.6 bg-thBg text-sm font-semibold text-lightBlack rounded-md"
                              key={index}>
                              {display}
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

function FormBuilder(props) {
  const {
    type,
    name,
    placeholder,
    onChange,
    defaultValue,
    occupations,
    onCreateOption,
    skills = "",
  } = props;
  let selectDefaultValue = [];
  // if (name === "skills" && skills) {
  //   selectDefaultValue = skills.map((value) => {
  //     let obj = _.find(occupations, { label: value });
  //     if (!_.isEmpty(obj)) {
  //       return { label: value, value: obj?.value };
  //     }
  //     return false;
  //   });
  // }

  if (type === "textarea") {
    return (
      <TextArea
        defaultValue={defaultValue}
        name={name}
        inputClass="p-4.5 text-base leading-6 text-lightBlack"
        rows={4}
        type="text"
        onChange={onChange}
      />
    );
  } else if (type === "select") {
    return (
      <CreatableSelect
        isMulti
        options={occupations}
        placeholder={placeholder}
        name={name}
        value={selectDefaultValue || null}
        height={58}
        onChange={(e) => onChange({ target: { name: name, value: e } })}
        onCreateOption={onCreateOption}
      />
    );
  }
  return <></>;
}
